export default "__VITE_ASSET__uuQzLBIm__"